namespace BizPrint {
    export enum ServerSideElementTypes {
        text = "Text",
        image = "Image",
        table = "Table",
        grid = "Grid",
        container = "Object",
        averyLabel = "Avery",
        barcode = "Barcode",
        html = "HTML",
        identifier = "Identifier",
    }


    export type TemplateDataLayerResponseDs = Array<TemplateElementResponseDs>;

    export type TemplateElementResponseDs =
        TemplateTextElementResponseDs
        | TemplateBarcodeElementResponseDs
        | TemplateImageElementResponseDs
        | TemplateElementObjectResponseDs
        | TemplateElementAveryResponseDs
        | TemplateHTMLElementResponseDs
        | TemplateElementTableResponseDs
        | TemplateElementGridResponseDs
        | TemplateIdentifierElementResponseDs;

    export type PropertyValue = string | boolean | number | Record<string, string | boolean | number>;

    interface IProperty {
        value?: PropertyValue;
        name?: string;
        editable?: boolean;
    }

    export interface TemplateGeneralElementResponseDs {
        title: string;
        name: string;
        properties?: Array<IProperty>,
    }

    export interface TemplateTextElementResponseDs extends TemplateGeneralElementResponseDs {
        type: ServerSideElementTypes.text;
        value: string | null;
    }

    export interface TemplateImageElementResponseDs extends TemplateGeneralElementResponseDs {
        type: ServerSideElementTypes.image;
        value: string | null;
    }

    export interface TemplateBarcodeElementResponseDs extends TemplateGeneralElementResponseDs {
        type: ServerSideElementTypes.barcode;
        value: string | null;
    }

    export interface TemplateElementObjectResponseDs extends TemplateGeneralElementResponseDs {
        type: ServerSideElementTypes.container;
        value: Array<TemplateElementResponseDs> | null;
    }

    export interface TemplateElementAveryResponseDs extends TemplateGeneralElementResponseDs {
        type: ServerSideElementTypes.averyLabel;
        value: Array<Array<TemplateElementResponseDs>> | null;
    }

    export interface TemplateElementGridResponseDs extends TemplateGeneralElementResponseDs {
        type: ServerSideElementTypes.grid;
        value: Array<Array<TemplateElementResponseDs>> | null;
    }

    export interface TemplateElementTableResponseDs extends TemplateGeneralElementResponseDs {
        type: ServerSideElementTypes.table;
        value: Array<Array<TemplateElementResponseDs>> | null;
    }

    export interface TemplateHTMLElementResponseDs extends TemplateGeneralElementResponseDs {
        type: ServerSideElementTypes.html;
        value: string | null;
    }

    export interface TemplateIdentifierElementResponseDs extends TemplateGeneralElementResponseDs {
        type: ServerSideElementTypes.identifier;
        value: string | null;
    }

    // ########################################## Page Data ##########################################

    // ------------------------
    // Product Information
    // ------------------------

    export interface ProductInformationPageData {
        title: string | undefined,
        partNo: string | undefined,
        upc: string | undefined,
        cost: number | undefined,
        avgCost: number | undefined,
        mainCategory: string | undefined,
        image: string | undefined,
        description: string | undefined,
    }

    // ------------------------
    // Product Labels
    // ------------------------

    export interface ProductLabelsPageDataLabel {
        partNo: string | undefined,
        upc: string | undefined,
        cost: number | undefined,
        avgCost: number | undefined,
        mainCategory: string | undefined,
        image: string | undefined,
        serialNo?: string | undefined,
        description: string | undefined,
    }

    export type ProductLabelsPageData = ProductLabelsPageDataLabel[];

    // ------------------------
    // Products Catalogue
    // ------------------------

    export interface ProductsCataloguePageDataCategory {
        title: string,
        colorCode: string,
        id: number,
    }

    export interface ProductsCataloguePageDataTechnicalProperty {
        title: string,
        value: string,
    }

    export interface ProductsCataloguePageDataTag {
        name: string | undefined,
        iconFileName: string | undefined,
    }

    export interface ProductsCataloguePageDataProduct {
        partNo: string | undefined,
        makeTitle: string | undefined,
        parentCategoryTitle: string | undefined,
        category: ProductsCataloguePageDataCategory,
        coverImageFileName: string | undefined,
        notes: string[],
        technicalProperties: ProductsCataloguePageDataTechnicalProperty[],
        amCode: string | undefined,
        oeCode: string | undefined,
        tags: ProductsCataloguePageDataTag[],
    }


    export type ProductsCataloguePageData = ProductsCataloguePageDataProduct[];

    // ------------------------
    // Products Brochure
    // ------------------------

    export interface ProductsBrochurePageDataGroupProduct {
        partNo: string | undefined,
        makeTitle?: string | undefined,
        coverImageFileName: string | undefined,
        note: string,
    }

    export interface ProductsBrochurePageDataGroup {
        title: string,
        colorCode: string,
        contrastColorCode: string,
        id: number | string,
        products: ProductsBrochurePageDataGroupProduct[],
    }

    export interface ProductsBrochurePageDataGroupDividerColorConfig {
        useGroupColor: boolean,
        colorCode: string,
    }

    export interface ProductsBrochurePageData {
        title: string;
        groups: ProductsBrochurePageDataGroup[],
        dividerColorConfig: ProductsBrochurePageDataGroupDividerColorConfig,
    }

    export type PackingListsPageData = {
        customer: {
            name: string,
            province: string,
            country: string,
            city: string,
            address: string,
            postalCode: string,
        },
        packingLists: Array<{
            id: string,
            dimension: string,
            weight: number,
            refNo: string,
            skidNumber: number,
            data: Array<{
                partNo: string,
                serialNo: string,
            }>
        }>,
    }


    export type TransactionReceiptPageData = {
        customerName?: string;
        customerAddress?: string;
        businessName?: string;
        businessAddress?: string;
        businessWebsite?: string;
        businessPhone?: string;
        businessEmail?: string;
        transactionAuthCode?: string;
        transactionTitle?: string;
        transactionDate?: string;
        transactionTotalAmount?: number;
        transactionType?: string;
        transactionReferenceNumber?: string;
        transactionItemDescription?: string;
        transactionItemAmount?: number;
        cardLast4Digits?: string;
        cardExpiry?: string;
        cardType?: string;
        status?: string;
    }

    export interface ApplicationData {
        partnerInfo: {
            name: string,
            fullAddress: string,
            phone: string,
            fax: string,
            logo: string,
            city: string,
            country: string,
            postalCode: string,
            province: string,
            website: string,
        },
    }
}

export default BizPrint;
